export enum ResponseErrorCodes {
  TryOtpLimitIsReached = 1,
  InvalidOtp = 2,
  SendOtpCoolDown = 3,
}

export const REQUEST_SMS_TIMER = 59;
